import React, { FC } from 'react';
import { IMultiSelect } from '@common/types/element';
import { View } from 'react-native';
import connectorInput from '../ConnectorInput';
import CustMultipleCheckbox from './CustMultipleCheckbox';

const MultipleCheckbox: FC<IMultiSelect> = (attributes) => {
  return (
    <View style={{ width: attributes.width }}>
      <CustMultipleCheckbox {...attributes} />
    </View>
  );
};

export default connectorInput(MultipleCheckbox);
